import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import Money from "../../common/moneyComponent";
import OldStyleTableWithHistory from "../../common/oldStyleTableWithHistory";

class Summary extends React.Component {
    render() {
        if (this.props.data.length === 0)
            return null;

        return (
            <OldStyleTableWithHistory stripped noMargin tableColumns={5}
                resolveExpanded={this.props.resolveExpanded}
                head={() => <thead>
                    <tr>
                        <th colSpan={3}></th>
                        <th><Translate id="Report.Procurements.ExpectedPrice" /></th>
                        <th><Translate id="Report.Procurements.FinalPrice" /></th>
                    </tr>
                </thead>}
                actualData={this.props.data.map((s, i) => ({ ...s, index: i }))}
                actualRow={(r) => <tr key={r.index} className="colorize">
                    <td style={{ fontWeight: "bold" }}><Translate id="Report.Procurements.Count" /></td>
                    <td>{r.count}</td>
                    <td><Translate id="Report.Procurements.Amount" data={{ currency: r.currency }} /></td>
                    <td><Money value={r.expectedPrice} fractionDigits={2} /></td>
                    <td><Money value={r.finalPrice} fractionDigits={2} /></td>
                </tr>}
            />
        )
    }
}

export default withLocalize((Summary));